export default __webpack_public_path__ + "static/media/2.d1e93315.png";